<template>
  <div class="input-group">
    <input id="clipboard" :value="email" readonly type="email" class="form-control" placeholder="Recipient's username">
    <span class="input-group-btn input-group-btn-append">
      <button class="btn btn-link" type="button" @click.prevent="copyToClipboard">
        <i class="fa fa-clipboard"></i>
      </button>
    </span>
  </div>
</template>

<script>

    export default {
        name: "match-confirmed-reveal-field-email-clipboard",
        props: {
            email: {
                type: String,
                required: true
            }
        },
        methods: {
            copyToClipboard () {
                return new Promise((resolve, reject) => {
                    var clipboard = document.getElementById('clipboard');
                    clipboard.select();
                    document.execCommand('copy');
                    resolve()
                }).then(() => {
                    this.$swal({
                      type: 'success',
                      title: 'Success',
                      text: 'Email address copied.',
                    });
                })
            }
        }
    }
</script>
